/*
 * Dinowax product page — gallery thumbnails.
 *
 * Progressive enhancement: with this file absent or still loading the gallery
 * shows its main image and the thumbnails are plain links to nothing harmful.
 *
 * The info accordion used to live here as a tab widget. It is now native
 * <details>, which needs no script at all.
 *
 * Variant selection lives in dw-product-form.js; this file only deals with
 * presentation.
 */
(function () {
  'use strict';

  if (window.DWProduct) { window.DWProduct.init(); return; }

  /* ---- gallery ---------------------------------------------------------- */
  function initGallery(root) {
    var galleries = root.querySelectorAll('[data-dw-gallery]:not([data-dw-gallery-ready])');
    Array.prototype.forEach.call(galleries, function (gal) {
      gal.setAttribute('data-dw-gallery-ready', 'true');
      var main = gal.querySelector('[data-dw-gallery-main]');
      var thumbs = gal.querySelectorAll('[data-dw-gallery-thumb]');
      if (!main || !thumbs.length) return;

      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-dw-gallery-thumb');
          if (!full) return;
          main.src = full;
          var alt = thumb.getAttribute('data-dw-gallery-alt');
          if (alt !== null) main.alt = alt;
          Array.prototype.forEach.call(thumbs, function (t) {
            t.classList.toggle('is-active', t === thumb);
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ---- variant -> gallery ----------------------------------------------- */
  /*
   * dw-product-form.js already dispatches dw:variant:change. Its root is
   * .dw-pmain__right, which is a SIBLING of the gallery rather than an
   * ancestor, so the listener sits on document and walks back down through the
   * nearest [data-dw-gallery-scope].
   *
   * That scope attribute is what keeps product cards out of this: a card also
   * dispatches this event, but no card sits inside a gallery scope, so closest()
   * returns null and the handler leaves.
   *
   * A variant with no image of its own is ignored rather than reset to the
   * product's default shot. Every "(case)" variant in this catalogue is
   * imageless, and yanking the gallery back to the 16oz bottle each time one
   * was picked would read as a bug.
   */
  function syncGalleryToVariant(e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    if (!e.target || !e.target.closest) return;

    var scope = e.target.closest('[data-dw-gallery-scope]');
    if (!scope) return;
    var gal = scope.querySelector('[data-dw-gallery]');
    if (!gal) return;
    var main = gal.querySelector('[data-dw-gallery-main]');
    if (!main) return;

    /* A case pack usually carries no photo of its own. This used to give up at
       the guard above and leave whatever was on screen, so going straight from
       16 oz to "1 Gal (4 case)" kept showing the 16 oz bottle — the stated rule
       is that it should show the gallon. imageFor resolves that from the variant
       titles, and returns null when nothing matches, which preserves the
       original behaviour of leaving the gallery alone rather than yanking it
       back to the product's default shot. */
    var form = e.target.dwProductForm;
    var pick = variant.image
      ? { url: variant.image, alt: variant.image_alt }
      : (form && form.imageFor ? form.imageFor(variant) : null);
    if (!pick || !pick.url) return;

    if (main.getAttribute('src') !== pick.url) main.src = pick.url;
    if (pick.alt) main.alt = pick.alt;

    var rail = gal.querySelector('[data-dw-gallery-rail]');
    var thumbs = gal.querySelectorAll('[data-dw-gallery-thumb]');
    Array.prototype.forEach.call(thumbs, function (t) {
      var on = t.getAttribute('data-dw-gallery-thumb') === pick.url;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-current', on ? 'true' : 'false');
      if (!on || !rail) return;
      // Nudge the rail itself rather than scrollIntoView, which is free to
      // scroll the whole page to reveal a thumbnail that was already visible.
      var rr = rail.getBoundingClientRect(), tr = t.getBoundingClientRect();
      if (rail.scrollHeight > rail.clientHeight + 2) {
        rail.scrollTop += (tr.top + tr.height / 2) - (rr.top + rr.height / 2);
      } else if (rail.scrollWidth > rail.clientWidth + 2) {
        rail.scrollLeft += (tr.left + tr.width / 2) - (rr.left + rr.width / 2);
      }
    });
  }

  document.addEventListener('dw:variant:change', syncGalleryToVariant);

  var DWProduct = {
    init: function (scope) {
      var root = scope || document;
      initGallery(root);
    }
  };

  window.DWProduct = DWProduct;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { DWProduct.init(); });
  } else {
    DWProduct.init();
  }

  document.addEventListener('shopify:section:load', function (e) { DWProduct.init(e.target); });
})();
